import * as React from 'react';

function SvgClock(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 101 100"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M92.96 40.234h-25a.783.783 0 00-.781.782v4.687c0 .43.352.781.781.781h25c.43 0 .782-.351.782-.78v-4.688a.784.784 0 00-.782-.782zM79.874 53.516H67.96a.784.784 0 00-.781.78v4.688c0 .43.352.782.781.782h11.914c.43 0 .782-.352.782-.782v-4.687a.784.784 0 00-.782-.781zM47.286 31.494h-4.228c-.606 0-1.094.488-1.094 1.094v24.219c0 .351.166.673.45.879l14.54 10.605a1.09 1.09 0 001.524-.234l2.51-3.428v-.01a1.092 1.092 0 00-.245-1.523L48.37 54.15V32.588a1.084 1.084 0 00-1.084-1.094z" />
      <path d="M79.269 65.811h-5.645c-.546 0-1.064.283-1.357.752a31.345 31.345 0 01-4.346 5.44 30.974 30.974 0 01-9.892 6.67 30.943 30.943 0 01-12.11 2.44c-4.209 0-8.281-.82-12.11-2.44a30.974 30.974 0 01-9.892-6.67 30.974 30.974 0 01-6.67-9.893A30.873 30.873 0 0114.806 50c0-4.208.82-8.27 2.441-12.109A30.974 30.974 0 0123.917 28a30.974 30.974 0 019.893-6.67 30.908 30.908 0 0112.11-2.442c4.208 0 8.28.82 12.109 2.442a30.974 30.974 0 019.892 6.67 31.34 31.34 0 014.346 5.439c.293.469.81.752 1.357.752h5.645a.893.893 0 00.8-1.299c-6.367-12.666-19.277-20.898-33.69-21.064-21.104-.264-38.634 17.011-38.673 38.095-.039 21.124 17.08 38.262 38.203 38.262 14.6 0 27.725-8.262 34.16-21.074a.896.896 0 00-.8-1.299z" />
    </svg>
  );
}

export default SvgClock;
